(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1591],{

/***/ 89602:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/[shortname]/finance-news",
      function () {
        return __webpack_require__(85592);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ CardInnerTitle; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);





var CardInnerTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("padding:1.5rem 1rem;border-bottom:2px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, ";display:flex;align-items:center;height:64px;", props.isSpaceBetween && "justify-content: space-between;"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("h3", {
                "data-test-id": props["data-test-id"],
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0 4px 0 0;font-size:16px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";"),
                children: props.title
            }),
            props.helpText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, {
                linkTo: props.helpLink || undefined,
                size: "large",
                children: props.helpText
            }),
            props.sub && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:14px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";margin:0 35px 0 16px;", props.subTitleCss),
                children: props.sub
            }),
            props.children
        ]
    });
};


/***/ }),

/***/ 33869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Help; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);





var Help = function(props) {
    var ref;
    if (props.linkTo) {
        var ref1;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
                label: props.children ? (ref1 = props.children) === null || ref1 === void 0 ? void 0 : ref1.toString() : "",
                id: "help",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                    href: props.linkTo,
                    target: "_blank",
                    rel: "noopener",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";vertical-align:middle;&:active,&:visited{color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";}"),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                        text: props.children,
                        className: props.className,
                        size: props.size,
                        offset: props.offset
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
            label: props.children ? (ref = props.children) === null || ref === void 0 ? void 0 : ref.toString() : "",
            id: "help",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                text: props.children,
                className: props.className,
                size: props.size,
                offset: props.offset
            })
        })
    });
};
var Icon = function(props) {
    var ref;
    var offset = "{'top': ".concat(((ref = props.offset) === null || ref === void 0 ? void 0 : ref.top) || 0, "}");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        "data-for": "help",
        "data-offset": offset,
        "data-tip": props.text,
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: "question-circle-fill",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:", props.size === "large" ? "20px" : "14px", ";")
        })
    });
};


/***/ }),

/***/ 50179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ InvestorFinanceNewsList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57923);
/* harmony import */ var _atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73367);
/* harmony import */ var _common_EmptyCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23581);
/* harmony import */ var _lib_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25769);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                    display: flex;\n                  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                      flex: 1;\n                      margin-left: 1rem;\n                    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 14px;\n                          color: ",
        ";\n                          line-height: 1.5;\n                          font-weight: ",
        ";\n                        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                        display: flex;\n                        align-items: center;\n                        margin: 4px 0;\n                      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 12px;\n                          line-height: 1.25;\n                          color: ",
        ";\n                          background-color: ",
        ";\n                          border-radius: 15px;\n                          padding: 3px 8px;\n                          margin: 0 8px 0 0;\n                        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 12px;\n                          line-height: 1.25;\n                          color: ",
        ";\n                          padding: 4px 0;\n                        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 14px;\n                          line-height: 1.25;\n                          font-size: 14px;\n                          color: ",
        ";\n                        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}








var InvestorFinanceNewsList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_3__/* .CardInnerTitle */ .W, {
                title: "資金調達・提携ニュース"
            }),
            props.list.length > 0 ? props.list.map(function(n, i) {
                var org = n.company ? n.company : n.investor;
                if (!org) {
                    return;
                }
                var categoryColor = (0,_lib_colors__WEBPACK_IMPORTED_MODULE_5__/* .getCategoryTagColor */ .O6)(n.category);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card.Content */ .Zb.Content, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject()),
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                                        href: org.path,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .CompanyLogo */ .Dc, {
                                            name: org.name,
                                            src: org.imageUrl
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1()),
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                                                href: n.urls[0],
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2(), plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.text */ .O9.text, plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold),
                                                    children: n.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                                                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject3()),
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject4(), categoryColor.color, categoryColor.backgroundColor),
                                                        children: n.category
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject5(), plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight),
                                                        children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_8__/* .formatDate */ .p6)(n.publishedAt, "yyyy/MM/dd")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                                                href: org.path,
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject6(), plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong),
                                                    children: org.name
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .iz, {})
                    ]
                }, i);
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_common_EmptyCard__WEBPACK_IMPORTED_MODULE_4__/* .EmptyCard */ .S, {})
        ]
    });
};


/***/ }),

/***/ 25769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ getCategoryTagColor; }
/* harmony export */ });
/* unused harmony exports convertHexColorToRGB, categoryTagColor */
var convertHexColorToRGB = function(hex) {
    if (hex.slice(0, 1) == "#") hex = hex.slice(1);
    if (hex.length == 3) {
        hex = hex.slice(0, 1) + hex.slice(0, 1) + hex.slice(1, 2) + hex.slice(1, 2) + hex.slice(2, 3) + hex.slice(2, 3);
    }
    return [
        hex.slice(0, 2),
        hex.slice(2, 4),
        hex.slice(4, 6)
    ].map(function(str) {
        return parseInt(str, 16);
    });
};
var categoryTagColor = {
    yellow10: "#FFFAEB",
    yellow60: "#D19D00",
    blue10: "#F2F6FA",
    blue60: "#0863BF",
    cyan10: "#F0F6F8",
    cyan60: "#1B8298",
    navy10: "#F2F4FA",
    navy60: "#1F3A8C",
    green10: "#F2FAF3",
    green60: "#2F943C",
    forestGreen10: "#F7FCEB",
    forestGreen60: "#6F9905",
    red10: "#FFF2F2",
    red60: "#db351f",
    brown10: "#F7F3F0",
    brown60: "#704831",
    gray20: "#FAFAFA",
    gray90: "#666"
};
var getCategoryTagColor = function(category) {
    switch(category){
        case "資金調達":
            return {
                color: categoryTagColor.yellow60,
                backgroundColor: categoryTagColor.yellow10
            };
        case "資本提携":
            return {
                color: categoryTagColor.forestGreen60,
                backgroundColor: categoryTagColor.forestGreen10
            };
        case "資金参加":
            return {
                color: categoryTagColor.brown60,
                backgroundColor: categoryTagColor.brown10
            };
        case "事業提携":
            return {
                color: categoryTagColor.blue60,
                backgroundColor: categoryTagColor.blue10
            };
        case "子会社化":
            return {
                color: categoryTagColor.red60,
                backgroundColor: categoryTagColor.red10
            };
        case "株式譲渡":
            return {
                color: categoryTagColor.navy60,
                backgroundColor: categoryTagColor.navy10
            };
        case "事業譲渡":
            return {
                color: categoryTagColor.cyan60,
                backgroundColor: categoryTagColor.cyan10
            };
        case "ファンド組成":
            return {
                color: categoryTagColor.green60,
                backgroundColor: categoryTagColor.green10
            };
        default:
            return {
                color: categoryTagColor.gray90,
                backgroundColor: categoryTagColor.gray20
            };
    }
};


/***/ }),

/***/ 85592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70655);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61753);
/* harmony import */ var _components_pages_investor_InvestorTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79181);
/* harmony import */ var _components_common_PaginationFromPageInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2146);
/* harmony import */ var _components_pages_investor_InvestorFinanceNewsList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50179);
/* harmony import */ var _lib_api_investor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70516);
/* harmony import */ var _lib_page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86234);











var FinanceNewsPage = function(props) {
    if (!props.summary) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_error__WEBPACK_IMPORTED_MODULE_1__["default"], {});
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_components_pages_investor_InvestorTemplate__WEBPACK_IMPORTED_MODULE_2__/* .InvestorTemplate */ .Z, {
        summary: props.summary,
        tab: "news",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_pages_investor_InvestorFinanceNewsList__WEBPACK_IMPORTED_MODULE_4__/* .InvestorFinanceNewsList */ .l, {
                list: props.news.data
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_common_PaginationFromPageInfo__WEBPACK_IMPORTED_MODULE_3__/* .PaginationFromPageInfo */ ._, {
                link: {
                    href: "/investor/finance-news?shortname=".concat(props.summary.shortname),
                    as: "/investors/".concat(props.summary.shortname, "/finance-news")
                },
                limit: props.news.limit,
                offset: props.news.offset,
                count: props.news.count
            })
        ]
    });
};
FinanceNewsPage.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(ctx) {
        var shortname, ref, limit, offset, investorSummaryResponse, ref1, summary, news;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    shortname = ctx.query.shortname.toString();
                    ref = (0,_lib_page__WEBPACK_IMPORTED_MODULE_6__/* .pageFromQuery */ .XT)(ctx.query), limit = ref.limit, offset = ref.offset;
                    return [
                        4,
                        (0,_lib_api_investor__WEBPACK_IMPORTED_MODULE_5__/* .fetchInvestorSummary */ .jM)(ctx, shortname)
                    ];
                case 1:
                    investorSummaryResponse = _state.sent();
                    return [
                        4,
                        Promise.all([
                            investorSummaryResponse === null || investorSummaryResponse === void 0 ? void 0 : investorSummaryResponse.data,
                            (0,_lib_api_investor__WEBPACK_IMPORTED_MODULE_5__/* .getFinanceNews */ .xX)(shortname, limit, offset)
                        ])
                    ];
                case 2:
                    ref1 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), summary = ref1[0], news = ref1[1];
                    return [
                        2,
                        {
                            summary: summary,
                            news: news
                        }
                    ];
            }
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (FinanceNewsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8687,519,8674,8101,774,3431,3954,2413,9181,5863,9774,2888,179], function() { return __webpack_exec__(89602); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);